import {
    Grid,
    GridProps,
    Heading,
} from '@chakra-ui/react';
import { DeliveryArticleShortCard } from 'entities/delivery-article';
import {
    SweetShopArticleRecommendationModel,
} from 'entities/sweet-shop-article';
import React from 'react';

export type SweetShopArticlePageMainRecommendationsSectionProps = {
    sweetShopArticleRecommendations: SweetShopArticleRecommendationModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const SweetShopArticlePageMainRecommendationsSection
: React.FC<SweetShopArticlePageMainRecommendationsSectionProps> = ({
    sweetShopArticleRecommendations,
    ...props
}) => (
    <Grid
        {...props}
        gap="2rem"
    >
        <Heading
            size="md"
            textDecoration="underline"
        >
            Вместе с этим, мы предлагаем
        </Heading>
        <Grid
            templateColumns={{
                base: '1fr 1fr',
                lg: '1fr 1fr 1fr 1fr',
            }}
            gap="2rem"
        >
            {sweetShopArticleRecommendations.map(({
                uid,
                name,
                weight,
                price,
                currency,
                image,
            }) => (
                <DeliveryArticleShortCard
                    name={name}
                    weight={weight || undefined}
                    price={price || undefined}
                    currencyAbbreviation={currency?.abbreviation || ''}
                    link={{
                        to: `/delivery/${uid}`,
                    }}
                    image={{
                        src: image?.url || '',
                    }}
                />
            ))}
        </Grid>
    </Grid>
);
